import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store";
import { AnyObject } from "../../../utils/basic";
import { getBestSellerProduct, getScreensaverData } from "../../actions/customizer";

export interface CustomizerState {
  data: null | AnyObject,
  isFetching: boolean;
  bestSellerProduct: null | AnyObject;
  screensaverData: null | AnyObject;
}

const initialState: CustomizerState = {
  data: null,
  isFetching: false,
  bestSellerProduct: null,
  screensaverData: null,
}

export const customizerSlice = createSlice({
  name: 'customizer',
  initialState: initialState,
  reducers: {
    setProductData: (state: CustomizerState, action: PayloadAction<object>) => {
      state.data = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getBestSellerProduct.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getBestSellerProduct.fulfilled, (state, action) => {
      state.isFetching = false;
      state.bestSellerProduct = action.payload;
    })
    .addCase(getBestSellerProduct.rejected, (state) => {
      state.isFetching = false;
    });
    builder.addCase(getScreensaverData.fulfilled, (state, action) => {
      state.screensaverData = action.payload ?? null;
    });
    builder.addCase(getScreensaverData.rejected, (state) => {
      state.screensaverData = null;
    });
  }
});

export const { setProductData } = customizerSlice.actions;

const customizerReducer = customizerSlice.reducer;

export const selectProduct = (state: RootState) => {
  return state.customizer.data
}

export default customizerReducer
